<template>
  <div class="modal-content">
    <div class="modal-body">
      <notification-details :value="selectedNotification" :allow-embedded="allowEmbedded" :settings="settings" v-on:save="save" v-on:close="hideModal" v-on:remove="remove" />
    </div>
  </div>
</template>

<script>

import NotificationDetails from '~/components/NotificationDetails'

export default {
  props: ['selectedNotification', 'allowEmbedded', 'settings'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (notification) {
      this.$emit('save', notification)
    },
    remove (notification) {
      this.$emit('remove', notification)
    }
  },
  components: {
    NotificationDetails
  }
}

</script>